import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';

export const getTaskComments = async (taskId) => {
  const res = await handleGetRequest(URI.task_comments(taskId), null, {
    toast: false,
    loading: false,
  });
  return res;
};

export const createComment = async (taskId, body) => {
  const res = await handlePostRequest(URI.task_comments(taskId), body, {
    toast: false,
    loading: false,
  });
  return res;
};

export const updateComment = async (id, body) => {
  const res = await handlePutRequest(URI.comment_by_id(id), body, {
    toast: false,
    loading: false,
  });
  return res;
};

export const deleteComment = async (id) => {
  const res = await handleDeleteRequest(URI.comment_by_id(id), {
    toast: false,
    loading: false,
  });
  return res;
};
